<template>
    <v-container
    style="height:100%"
    class="d-flex flex-column"
    >
        <v-row
        no-gutters
        class="mt-2 mb-4"
        >
            <v-col cols="12">
                <slot name="viewHeader"></slot>
            </v-col>
        </v-row>
        <v-card
        height="100%"
        class="d-flex flex-column"
        >
            <div
            style="border-bottom-left-radius:0; border-bottom-right-radius: 0;"
            class="grey lighten-5"
            >
                <h4
                class="pa-4"
                >
                    <slot name="cardTitle">
                    </slot>
                </h4>
            </div>
            <slot name="cardBody">
            </slot>
        </v-card>
    </v-container>
</template>

<script>
export default {
  name: 'ViewCardTemplate',
};
</script>

<style lang="scss" scoped>

.login-container {
   background-image: url("~@/assets/background.png"); /* Replace with the path to your PNG image */
   background-size: cover;
   background-position: center;
   min-height: 100vh;
 }
 .content-card {
  min-height: 100%; /* The card will expand to accommodate its content */
  display: flex;
  flex-direction: column; /* Ensures the content is stacked vertically */
  border-bottom-left-radius:0;
  border-bottom-right-radius: 0;
}
</style>
